import { api } from '../axios'
import type {
  ApiResponse,
  UserProfile,
  UpdateProfileInput,
  Facility,
  UpdateFacilityInput,
} from '@/types'

export const settingsService = {
  async getProfile(): Promise<UserProfile> {
    const response = await api.get<ApiResponse<UserProfile>>('/user/profile')
    return response.data.data
  },

  async updateProfile(data: UpdateProfileInput): Promise<UserProfile> {
    const response = await api.patch<ApiResponse<UserProfile>>('/user/profile', data)
    return response.data.data
  },

  async getFacility(): Promise<Facility> {
    const response = await api.get<ApiResponse<Facility>>('/facility')
    return response.data.data
  },

  async updateFacility(data: UpdateFacilityInput): Promise<Facility> {
    const response = await api.patch<ApiResponse<Facility>>('/facility', data)
    return response.data.data
  },
}
